import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { AuthService } from "projects/sepidz-web-framework/src/lib/services";
import { CurrentBranch } from "projects/sepidz-web-framework/src/lib/models/current-branch.model";
import { form_control, Branch, FiscalYear } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { BaseFormComponent } from "../../shared/controls/base/base-form.component";
import { TabularService } from "../../tabular/tabular.service ";
import { SelectorService } from "../../shared/controls/base/selector.service";
@Component({
  selector: "ngx-current-branch-form",
  templateUrl: "./current-branch-form.component.html",
  styleUrls: ["./current-branch-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentBranchFormComponent extends BaseFormComponent<CurrentBranch> {
  currentBranch: Branch;
  currentFiscalYear: FiscalYear;
  constructor(
    private authService: AuthService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private _tabularService: TabularService
  ) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "FiscalYear/FiscalYear";
    this.areaName = "General";
    this.label = this.translate("ClientApp.Projects.FrameWorkShell.CurrentBranchForm.FiscalYearSelection");
    super.ngOnInit();
  }
  setdefault() {
    if (this.authService.currentFiscalYear) {
      this.model.BranchId = this.authService.currentFiscalYear.Id;
      this.model.Year = this.authService.currentFiscalYear.Year;
      this.model.FiscalYearId = this.authService.currentFiscalYear.Id;
      this.model.Year = this.authService.currentFiscalYear.Year;
    }
  }
  async setColumns() {
    this.columns = [];
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.Projects.FrameWorkShell.CurrentBranchForm.FiscalYear"),
      controlType: FormControlTypes.dropdown,
      modelName: "FiscalYearId",
      disabled: false,
      name: "FiscalYearId",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      apiName: this.apiName,
      valueMember: "Id",
      displayMember: "Year",
    });
    this.orignalColumns = this.columns;
    this.setFormGroup(this.model);
  }
  addControl() {
    this.setValue("FiscalYearId", this.model.FiscalYearId);
  }
  async save() {
    if (this.currentFiscalYear) this.authService.saveFiscalYear(this.currentFiscalYear);
    this._tabularService.closeAll();
    this.close();
  }
  onChanged($event) {
    if ($event.Year) {
      this.currentFiscalYear = $event as FiscalYear;
      this.authService.saveFiscalYear(this.currentFiscalYear);
    }
  }
}
